import { useTranslation } from 'i18n';
import { Box, Button, Page, Section } from 'ui';

import { FindTicketsTable } from '../../components/FindTicketsTable/FindTicketsTable';
import { useFindTicketsTitle } from '../../hooks/useFindTicketsTitle/useFindTicketsTitle';

export const FindTickets = () => {
  const { t } = useTranslation('orders');
  const title = useFindTicketsTitle();

  const onOpenIssueClick = () => {
    const url = new URL('/support/ticket/', window.location.href);
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => url.searchParams.set(key, value));
    window.open(url.toString(), '_blank');
  };

  return (
    <Page>
      <Page.Title title={title} />
      <Page.Divider />
      <Section>
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Button onClick={onOpenIssueClick}>{t('supportTicketsFindTickets.actions.openIssue')}</Button>
        </Box>
        <FindTicketsTable />
      </Section>
    </Page>
  );
};
